export default {
    results(state) {
        return state.results;
    },
    courseNameById: (state) => (id) => {
        return state.courseName[id]
    }
};
